import type { RotaryKiln, RotaryKilnPlantKilnRef } from '../../../types/reports.js';
import { BASE_PATH as PLANT_KILNS_BASE_PATH } from '../../../services/plantKilnsApi.js';

// Phase 28 (D-23, Plan 28-06): ersetzt den fruehen Leerstring-Workaround aus 19-10 fuer
// `kilnName` -- der ist mit der Anzeige-only-Umstellung (D-23) hinfaellig. Das Backend liefert
// den Stammdaten-Ofen beim Lesen als eingebettetes Objekt (`plantKiln: { id, name, ... }`,
// RotaryKilnPlantKilnRef), erwartet beim Schreiben aber eine Referenz-IRI --
// RotaryKiln::$plantKiln ist `#[Groups(['report:read', 'report:write'])]` und wird ueber eine
// normale ManyToOne-Relation denormalisiert. Wuerde das eingebettete Objekt unveraendert
// zurueckgeschickt, versuchte die Denormalisierung, an den Stammdaten selbst zu schreiben; wuerde
// `plantKiln` gar nicht gesendet, verloere die neu geschriebene Ofenzeile ihren Stammdatenbezug --
// die `rotaryKilns`-Collection wird serverseitig bei jedem Speichern vollstaendig ersetzt
// (orphanRemoval, siehe RotaryKiln.php-Kommentar zu EnvironmentalData::$rotaryKilns).
//
// `kilnName` bleibt im Nutzlast-Objekt erhalten, obwohl es im Formular nicht mehr editierbar ist
// (D-23): die Zeile wird serverseitig neu geschrieben, ein fehlender Name verletzt
// `Assert\NotBlank` auf RotaryKiln::$kilnName.
export function serializeRotaryKilnsForSave(kilns: RotaryKiln[]): Record<string, unknown>[] {
  return kilns.map((kiln) => {
    const { plantKiln, ...rest } = kiln;
    return {
      ...rest,
      plantKiln: plantKiln ? plantKilnToIri(plantKiln) : null,
    };
  });
}

// Eingebettetes plantKiln bevorzugt ueber die vom Backend mitgelieferte '@id' (JSON-LD); ohne sie
// (RotaryKilnPlantKilnRef ohne '@id', z.B. in Tests oder aelteren Zwischenstaenden) wird die IRI
// aus der numerischen id und dem Ressourcenpfad der plantKilnsApi gebildet.
function plantKilnToIri(plantKiln: RotaryKilnPlantKilnRef): string {
  return plantKiln['@id'] ?? `${PLANT_KILNS_BASE_PATH}/${plantKiln.id}`;
}
